import { createFeature, createReducer, on } from '@ngrx/store'

import {
  loadLoginHistories,
  loadLoginHistoriesSuccess,
  loadLoginHistoriesFailure,
  resetLoginHistoryState
} from './login-history.actions'

import { LoginHistoryState } from './login-history.state'

export const initialState: LoginHistoryState = {
  loginHistories: [],
  totalCount: 0,

  successfulLoginCount: 0,
  failedLoginCount: 0,
  loggedOutLoginCount: 0,
  totalRowCount: 0,
  loading: false,
  error: null
}

export const loginHistoryReducer = createReducer(
  initialState,

  on(loadLoginHistories, state => ({
    ...state,
    loading: true,
    error: null
  })),

  on(
    loadLoginHistoriesSuccess,
    (
      state,
      {
        loginHistories,
        totalCount,
        totalRowCount,
        successfulLoginCount,
        failedLoginCount,
        loggedOutLoginCount
      }
    ) => ({
      ...state,
      loginHistories,
      totalCount,
      totalRowCount,
      successfulLoginCount,
      failedLoginCount,
      loggedOutLoginCount,
      loading: false,
      error: null
    })
  ),

  on(loadLoginHistoriesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),

  on(resetLoginHistoryState, () => initialState)
)

export const loginHistoryFeature = createFeature({
  name: 'loginHistory',
  reducer: loginHistoryReducer
})

export type { LoginHistoryState }

export const {
  name,
  reducer,
  selectLoginHistories,
  selectTotalCount,
  selectTotalRowCount,
  selectLoading,
  selectFailedLoginCount,
  selectLoggedOutLoginCount,
  selectSuccessfulLoginCount,
  selectError
} = loginHistoryFeature
